import React, { useMemo } from "react";
import { Modal } from "react-bootstrap";
import { Viewer } from "./components/Viewer/Viewer";
import { ARButton } from "./components/ARButton/ARButton";
import { BuyNowButton } from "./components/BuyNowButton/BuyNowButton";
import { ContactUsButton } from "./components/ContactUsButton/ContactUsButton";
import { ImageCarousel } from "./components/ImageCarousel/ImageCarousel";
import { IndicationComponent } from "./components/IndicationComponent/IndicationComponent";
import { KeySpec } from "./components/KeySpec/KeySpec";
import { PdfButton } from "./components/PdfButton/PdfButton";
import { ProductDetailsButton } from "./components/ProductDetailsButton/ProductDetailsButton";
import { ProductTitleComponent } from "./components/ProductTitle/ProductTitle";
import { Switch } from "./components/Switch/Switch";
import { VariantProduct } from "./components/VariantProduct/VariantProduct";
import { VideoButton } from "./components/VideoButton/VideoButton";
import styles from "./ProductModal.module.scss";

const ProductModal = ({
  openVideoModal,
  setVariant,
  handleClose,
  selectedProduct,
  variationOptions,
  openPdfModal,
  closePdfModal,
  openPdf,
  toggleSwitch,
  twoDActive,
  threeDActive,
}) => {
  return useMemo(() => {
    if (!selectedProduct) return null;
    const { Model, Indication, VideoLink, ContactUs, PdfPath, BuyNow, ARLink } = selectedProduct;

    return (
      <Modal backdrop={false} show={Boolean(selectedProduct)} onHide={handleClose}>
        <div className={styles.container}>
          <div className={styles.mainContent}>
            {selectedProduct.ViewerPath && <Switch toggleSwitch={toggleSwitch} twoDActive={twoDActive} threeDActive={threeDActive} />}
            {twoDActive && <ImageCarousel product={selectedProduct} />}
            {threeDActive && <Viewer product={selectedProduct} />}
            <div className={styles.titleAndKeySpecs}>
              <ProductTitleComponent product={selectedProduct} variationOptions={variationOptions} />
              <KeySpec product={selectedProduct} />
            </div>
            <div>{Indication && <IndicationComponent Indication={Indication} />}</div>
            <div className={styles.btnContainer}>
              <ProductDetailsButton product={selectedProduct} />
              {PdfPath && <PdfButton product={selectedProduct} openPdfModal={openPdfModal} />}
              {ContactUs && <ContactUsButton product={selectedProduct} Model={Model} />}
              {VideoLink && <VideoButton openVideoModal={openVideoModal} Model={Model} />}
              {BuyNow && <BuyNowButton product={selectedProduct} Model={Model} />}
              {ARLink && <ARButton product={selectedProduct} Model={Model} />}
            </div>
          </div>
          <div className={styles.productDetailsColumn}>
            <div className={styles.productContent}>
              <p className={styles.recProductHeading}>You may also like</p>
              <button onClick={handleClose} type="button" className={styles.close} data-dismiss="modal">
                <img src={process.env.PUBLIC_URL + `/images/close.svg`} className={styles.closeBtn} alt="Close Button" />
              </button>
              {variationOptions && (
                <VariantProduct variantOptions={variationOptions} openVideoModal={openVideoModal} setVariant={setVariant} />
              )}
            </div>
          </div>
        </div>
      </Modal>
    );
  }, [selectedProduct, handleClose, setVariant, variationOptions, openVideoModal, openPdfModal, threeDActive, twoDActive, toggleSwitch]);
};

export { ProductModal };
